module.exports = __webpack_public_path__ + "static/img/logo_7777.502ef95b.png";